import { Component, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { from } from "rxjs";
import { tap } from "rxjs/operators";
import { AgRendererComponent } from "ag-grid-angular";
import { LoaderService } from '../../services/loader.service';
import { DynamicDialogService } from "../../../core/services/dynamic-dialog.service";
import { Dialog, DialogButton } from "../../../core/models/dialog.model";

@Component({
    selector: 'app-router-link-renderer',
    templateUrl: './router-link-renderer.component.html',
    standalone: false
})
export class RouterLinkRendererComponent implements AgRendererComponent {

    id: any;
    confirmDialog: Dialog = new Dialog("", [new DialogButton("Yes", true, () => this.onNavigationConfirm()), new DialogButton("No", false, () => this.onNavigationCancel())]);
    confirmMessage: string = "";
    confirmNavigation: boolean = false;
    openInNewWindow: boolean = false;
    enableLink: boolean = true;
    params: any;
    linkText: string;
    url: string;

    constructor(public ngZone: NgZone,
        public router: Router,
        public loader: LoaderService,
        public dialogService: DynamicDialogService) { }

    agInit(params: any): void {

        this.params = params;
        if (params.data) {
            this.id = params.data[params.idField];

            if (params.text) {
                this.linkText = params.text;
            } else if (params.textField) {
                this.linkText = (params.data[params.textField] && params.data[params.textField].length > 0) ? params.data[params.textField] : "Unknown";
            } else if (params.enumValueField && params.enum) {
                this.linkText = (params.enum as IdDescriptionPair[]).find(x => x.id === params.data[params.enumValueField]).description;
            } else if (params.textFunction) {
                this.linkText = params.textFunction(params);
            }

            if (params.page == 'registration') {
                this.params.url = params.data.targetUrl;
                this.linkText = params.data.reviewTitle;
            }

            if (params.url && typeof (params.url) == 'function') {
                params.url = params.url(params.data);
            }
            if (!params.url && params.data.targetUrl) {
                params.url = params.data.targetUrl;
            }
            if (params.openInNewWindow !== undefined && params.openInNewWindow !== null) {
                this.openInNewWindow = params.openInNewWindow;
            }
            if (params.flowIdField) {
                params.url = `/flow/${params.data[params.flowIdField]}`;
                if (params.workItemIdField) {
                    if (params.data[params.workItemIdField]) {
                        params.url = params.url + "/" + params.data[params.workItemIdField];
                    }
                }
            }
            if (params.onBehalfIdField) {
                params.url = `/flow/on-behalf/${params.data[params.onBehalfIdField]}`;
            }

            if (params.function)
                params.url = params.function(params.data);

            if (params.confirmNavigation) {
                this.confirmNavigation = params.confirmNavigation;
                this.confirmMessage = params.confirmMessage;
            }

            if (params.enableLink != null) {
                this.enableLink = params.enableLink(params.data);
            }

            this.url = params.url;
        }

        // ag-grid keeps DOM focus on the cell wrapper, not the inner <a>, so the anchor's
        // native "Enter activates the focused link" behavior never fires - listen on the cell
        // itself instead, matching the other interactive cell renderers (see INTERACTIVE_CELL_RENDERERS).
        params.eGridCell?.addEventListener('keydown', (event: KeyboardEvent) => {
            if ((event.key === ' ' || event.key === 'Enter') && this.enableLink) {
                event.preventDefault();
                this.navigate(this.url);
            }
        });
    }

    onNavigationConfirm(): void {
        this.doNavigation();
    }

    onNavigationCancel(): void {

    }

    doNavigation() {
        if (!this.params.preventNavigation) {
            this.loader.toggleLoader(true);
            if (this.id) {
                this.ngZone.run(() => {
                    from(this.router.navigate([this.url, this.id])).pipe(tap(() => { this.loader.toggleLoader(false); })).toPromise(); });
            } else {
                this.ngZone.run(() => { from(this.router.navigate([this.url])).pipe((tap(() => { this.loader.toggleLoader(false); }))).toPromise(); });
            }
        }
    }

    refresh(params: any): boolean {
        return false;
    }

    onLinkClick(event: Event): void {
        event.preventDefault();
        this.navigate(this.url);
    }

    navigate(link) {
        if (this.confirmNavigation) {    
            this.confirmDialog.message = this.confirmMessage;
            this.confirmDialog.toggleDialog(true);
            this.dialogService.updateDialog(this.confirmDialog);
        } else {
            this.doNavigation();
        }
    }
}

export interface IdDescriptionPair {
    id: string;
    description: string;
}
